export interface ResearchVariant {
  id: string; title: string; decisions: number; rebalances: number; marks: number;
  last_observed_at: string | null; return_pct: number | null; cost2x_return_pct: number | null;
  mdd_pct: number | null; open_positions: number; failure_count: number;
  recent_failures: { at: string; reason: string }[];
  path: { at: string; baseline: number; cost2x: number }[];
}
export interface ResearchOverview {
  macro_context?: {status: string; samples: number | null; start_utc?: string; end_utc?: string;
    generated_at?: string; report_stale?: boolean; conditions?: Record<string, Record<string, {count: number; mean_daily_return: number | null}>>};
  as_of: string; read_pending?: boolean;
  forward: {
    status: string; start?: string; end?: string; finalize_after?: string;
    virtual_capital?: number; universe_size?: number; code_frozen?: boolean;
    ledger_integrity: string; error?: string; error_count?: number;
    scheduler?: { registered: boolean; entry_present: boolean | null; fresh: boolean | null; last_run: string | null };
    variants: ResearchVariant[];
  };
  studies: {
    id: string; title: string; reason: string; status: string; document_id: string;
    metrics: { label: string; return_pct: number; cost2x_pct: number; mdd_pct: number }[];
  }[];
  shadows: { id: string; title: string; status: string; start?: string; end: string;
    reported_at: string | null; report_stale: boolean | null;
    observed_until?: string | null; progress_pct?: number | null; error?: string;
    metrics: { id: string; title: string; return_pct: number | null; cost2x_return_pct: number | null;
      mdd_pct: number | null; closed_trades: number | null; open_positions: number | null; basis: string; cost_basis: string }[];
  }[];
}
export const phaseLabel: Record<string, string> = {
  waiting_for_start: "시작 대기", observing: "전진 관찰 중", observation_period: "관찰 기간",
  awaiting_final_audit: "최종 감사 대기", finalized: "최종 기록 완료", awaiting_review: "판정 대기",
  blocked: "동결 코드 변경 · 중단", unavailable: "근거 확인 필요", updating: "기록 갱신 중",
};
